// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"13":"40c16d31","346":"ab82233d"}[chunkId] + ".chunk.css";
};